module.exports = __webpack_public_path__ + "static/media/milho-auati.1528bd8a.png";